import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type Props = {
	contributorCount: number;
};

export const ContributorsSkeleton = ({ contributorCount }: Props) => (
	<Container>
		{[...Array(contributorCount)].map((_, i) => (
			<SkeletonGroup key={i} />
		))}
	</Container>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.ul({
	listSyleType: 'none',
	position: 'relative',
	margin: 0,
	padding: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonGroup = styled.li({
	width: ' 24px',
	height: ' 24px',

	backgroundColor: token('color.skeleton'),
	display: 'inline-block',
	borderRadius: '50%',
	borderWidth: '2px',
	borderStyle: 'solid',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	borderColor: 'white',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:nth-of-type(n+2)': {
		marginLeft: token('space.negative.150'),
	},
});
